import { create } from "zustand"

interface AdminUser {
    userId: string
    role: string
    email: string
    needsReconsent?: {
        terms: boolean
        privacy: boolean
        currentTermsVersion: string
        currentPrivacyVersion: string
    }
}

interface AdminAuthStore {
    user: AdminUser | null
    setUser: (user: AdminUser | null) => void
    logout: () => void
}

export const useAdminAuthStore = create<AdminAuthStore>((set) => ({
    user: null,
    setUser: (user) => set({ user }),
    logout: () => set({ user: null }),
}))
